const createComponentNamespace = ({ component, componentList, namespace })=>{
    for (const [componentName, component] of Object.entries({
        ...componentList
    }))component.displayName = `${namespace}.${componentName}`;
    const ComponentNamespace = Object.assign(component, componentList);
    return ComponentNamespace;
};
export { createComponentNamespace };
